export default "__VITE_ASSET__$KW2O5hX__"